import { isMobile } from "../common/utils";

const initialize = () => {
  const headerEl = document.querySelector("header.section-fs-header");
  if (!headerEl) {
    return;
  }
  adjustTop();
  addButtonEvents(headerEl);
  addScrollEvent(headerEl);
  addResizeEvent(headerEl);
};

const adjustTop = () => {
  const announcementEl = document.querySelector("#shopify-section-announcement-bar");
  if (announcementEl) {
    const rect = announcementEl.getBoundingClientRect();
    document.documentElement.style.setProperty("--fs-announcement-bar-bottom", `${rect.bottom}px`);
  }
  const headerBarEl = document.querySelector("#shopify-section-header .fs-header");
  if (headerBarEl) {
    const rect = headerBarEl.getBoundingClientRect();
    document.documentElement.style.setProperty("--fs-header-bar-bottom", `${rect.bottom}px`);
  }
};

const addButtonEvents = (headerEl) => {
  const searchButton = headerEl.querySelector(".fs-buttons .fs-search-button");
  searchButton.addEventListener("click", () => {
    const searchDrawer = document.querySelector("#fs-search-drawer");
    searchDrawer.dispatchEvent(new CustomEvent("show"));
  });

  const menuButton = headerEl.querySelector(".fs-buttons .fs-menu-button");
  menuButton.addEventListener("click", () => {
    const menuDrawer = document.querySelector("#fs-menu-drawer");
    menuDrawer.dispatchEvent(new CustomEvent("show"));
  });
};

const addScrollEvent = (headerEl) => {
  let lastY = 0;
  const headerNavSpEl = document.querySelector(".section-fs-header-nav-sp");
  const announcementEl = document.querySelector("#shopify-section-announcement-bar");
  window.addEventListener("scroll", () => {
    if (window.scrollY < lastY) {
      headerNavSpEl.classList.add("show");
    } else {
      headerNavSpEl.classList.remove("show");
      hideAllSubmenus(headerEl);
    }
    if (isMobile()) {
      if (window.innerHeight < window.scrollY) {
        announcementEl.classList.add("small");
        setTimeout(() => {
          adjustTop();
        }, 100);
      } else {
        if (announcementEl.classList.contains("small")) {
          announcementEl.classList.remove("small");
          setTimeout(() => {
            adjustTop();
          }, 100);
        }
      }
    }
    lastY = window.scrollY;
  });
};

const addResizeEvent = (headerEl) => {
  window.addEventListener("resize", () => {
    adjustTop();
    hideAllSubmenus(headerEl);
  });
};

const hideAllSubmenus = (headerEl) => {
  headerEl.querySelectorAll(".fs-nav-item.has-submenu .fs-submenu").forEach((submenu) => {
    submenu.classList.remove("show");
  });
  const headerNavSpEl = document.querySelector(".section-fs-header-nav-sp");
  headerNavSpEl.querySelectorAll(".fs-nav-item.has-submenu .fs-submenu").forEach((submenu) => {
    submenu.classList.remove("show");
  });
};

/*
 * Main
 */

addEventListener("DOMContentLoaded", (event) => {
  initialize();
});

window.addEventListener("pageshow", (event) => {
  adjustTop();
});
